<!--录入提示页-->
<template>
  <div class="content dialog-root"
  >
    <p class="title-b">填表说明管理</p>
    <p class="line-gray"></p>
    <div class="action-con">
      <label class="action-title">一级模块：</label>
      <el-select v-model="model0" filterable placeholder="请选择" @change="model0SelectChange"
                 :clearable="true">
        <el-option
          v-for="(item,index) in model0SearchList"
          :key="index"
          :value="item.model_1">
        </el-option>
      </el-select>

      <label class="action-title title-left">二级模块：</label>
      <el-select v-model="model1" filterable placeholder="请选择" :clearable="true">
        <el-option
          v-for="(item,index) in model1SearchList"
          :key="index"
          :value="item.model_2">

        </el-option>
      </el-select>

      <label class="action-title title-left">字段名称：</label>
      <div class="searchCon">
        <el-input v-model="searchName" placeholder="请输入字段名称" :clearable="true"
                  name="searchName"></el-input>
      </div>
      <a class="btnCommon searchBtn" @click="getListData">查询</a>
      <a class="btnCommon addBtn" @click="handleEdit">添加填表说明</a>
      <a class="btnCommon lotDelBtn" @click="handleDelete">批量删除</a>
    </div>

    <!--表格-->
    <div class="tableCon" ref="tableCon" v-loading="ifLoading">
      <el-table
        :data="dataList"
        style="width: 100%"
        :max-height="tableHeight"
        :cell-style="tableCellStyle"
        :header-cell-style="headerCellStyle"
        ref="table"
        border
      >
        <el-table-column
          type="selection"
          width="33px"
        >
        </el-table-column>
        <el-table-column
          label="序号"
          type="index"
          width="58px"
          align="center"
        >
        </el-table-column>
        <el-table-column
          label="一级模块"
          min-width="120px"
          prop="model_1"
          align="center"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          label="二级模块"
          min-width="167px"
          prop="model_2"
          align="center"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          label="模块说明"
          min-width="285px"
          prop="model_info"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          label="字段名"
          min-width="90px"
          prop="field_name"
          align="center"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          label="字段说明"
          min-width="237px"
          prop="field_info"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          label="操作"
          min-width="132px"
          align="center"
        >
          <template slot-scope="scope">
            <a class="action-common" href="javascript:;"
               @click="handleEdit(scope.$index, scope.row)">编辑
            </a>
            <a class="action-left action-common" href="javascript:;"
               @click="handleSave(scope.$index, scope.row)">另存为
            </a>
            <a class="action-left action-common action-del" href="javascript:;"
               @click="handleDelete(scope.$index, scope.row)">删除
            </a>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <p class="pagination-con">
      <el-pagination
        background
        layout="prev, pager, next, total,sizes, jumper"
        :page-size.sync="pagesize"
        :current-page.sync="pageindex"
        :total="totalNum"
        :page-sizes="[1,10, 20, 30, 40,50,60,70,80,90,100]"
        @size-change="sizeChangeListener"
      >
      </el-pagination>
    </p>

    <!--编辑填表说明弹窗-->
    <el-dialog
      :visible.sync="dialogShow"
      :title="dialogTitle"
      width="711px"
    >
      <div class="dialog-con">
        <p class="inputHint"><span class="red">温馨提示：</span>带 * 的为必填项</p>
        <div class="input-con">
          <label><span>*</span>一级模块：</label>
          <el-autocomplete
            class="inputCommon"
            :maxlength="25"
            v-model="model0Name"
            placeholder="请输入一级模块"
            :clearable="true"
            :fetch-suggestions="model0Search"
            @change="inputChange"
            @select="model0Select">
            <template slot-scope="{ item }">
              <div class="itemName">{{ item.model_1 }}</div>
            </template>
          </el-autocomplete>
          <div v-if="show0" class="showText" ref="show0">不能为空！</div>
        </div>
        <div class="input-con">
          <label><span>*</span>二级模块：</label>
          <el-autocomplete
            class="inputCommon"
            :maxlength="25"
            v-model="model1Name"
            placeholder="请输入二级模块"
            :clearable="true"
            :fetch-suggestions="model1Search"
            @select="model1Select">
            <template slot-scope="{ item }">
              <div class="itemName">{{ item.model_2 }}</div>
            </template>
          </el-autocomplete>
          <div v-if="show1" class="showText" ref="show1">不能为空！</div>
        </div>

        <div class="input-con textarea-con">
          <label><span>*</span>模块说明：</label>
          <el-input
            class="inputCommon"
            :maxlength="1000"
            v-model="modelShow"
            placeholder="请输入模块说明"
            type="textarea"
            resize="none"
          >
          </el-input>
          <div v-if="show2" class="showText" ref="show2">不能为空！</div>
        </div>

        <div class="input-con">
          <label><span>*</span>字段名称：</label>
          <el-input
            class="inputCommon"
            :maxlength="25"
            v-model="fieldName"
            :clearable="true"
            placeholder="请输入字段名称"
          >
          </el-input>
          <div v-if="show3" class="showText" ref="show3">不能为空！</div>
        </div>

        <div class="input-con textarea-con">
          <label><span>*</span>字段说明：</label>
          <el-input
            class="inputCommon"
            :maxlength="1000"
            v-model="fieldShow"
            placeholder="请输入字段说明"
            type="textarea"
            resize="none"
          >
          </el-input>
          <div v-if="show4" class="showText" ref="show4">不能为空！</div>
        </div>
        <a class="saveBtn" @click="saveFunc">保存</a>
        <el-checkbox v-model="goonCB">继续为该模块添加新的字段说明</el-checkbox>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: 'InputShow'
    , data () {
      return {
        model0: '' // 模块一搜索名
        , model1: '' // 模块二搜索名
        , searchName: '' // 搜索字段名称
        , pagesize: 50 // 每页条数
        , pageindex: 1 // 当前页码
        , dataList: [] // 数据列表
        , tableHeight: '100%' // 列表的最小高度
        , tableCellStyle: {
          'padding': '0'
        } // 列表单元格样式
        , headerCellStyle: {
          'height': '36px'
          , 'padding': '0'
        } // 表头单元格样式
        , isEdit: true // 是否为编辑打开
        , curGuid: '' // 当前guid
        , ifLoading: false // 是否显示加载遮罩
        , totalNum: 0 // 列表总数

        // 弹窗变量 ↓↓↓↓↓↓↓
        , dialogShow: false // 弹窗显示
        , dialogTitle: '编辑填表说明'
        , model0Name: '' // 模块一名称
        , model1Name: '' // 模块二名称
        , modelShow: '' // 模块说明
        , fieldName: '' // 字段名称
        , fieldShow: '' // 字段说明
        , model0SearchList: [] // 模块一搜索集合
        , model1SearchList: [] // 模块二搜索集合
        , goonCB: false // 继续为该模块添加新的字段说明

        // 提示显示
        , show0: false
        , show1: false
        , show2: false
        , show3: false
        , show4: false
      }
    }
    , methods: {
      // 获取列表数据
      getListData () {
        let params = {
          module_1: this.model0
          , module_2: this.model1
          , zdmc: this.searchName
          , pagesize: this.pagesize
          , pageindex: this.pageindex
        }
        this.ifLoading = true
        this.$axios.post('Regest/GetInputTipList_FY', params)
          .then((res) => {
            this.ifLoading = false
            let data = res.data
            if (data.isError == 'False') {
              this.dataList = data.result.Table
            } else {
              this.$message({
                message: '列表请求失败!'
                , type: 'warning'
              })
            }
          })
          .catch((err) => {
            this.ifLoading = false
            this.$message({
              message: '列表请求失败!'
              , type: 'warning'
            })
          })

        // 请求总数
        this.$axios.post('Regest/GetInputTipList_Sum', params)
          .then((res) => {
            let data = res.data
            if (data.isError == 'False') {
              this.totalNum = data.result.Table[0].number
            } else {
              this.$message({
                message: '列表条目数量请求失败!'
                , type: 'warning'
              })
            }
          })
          .catch((err) => {
            this.ifLoading = false
            this.$message({
              message: '列表条目数量请求失败!'
              , type: 'warning'
            })
          })

      }
      // 模块一选择框选中监听
      , model0SelectChange (value) {
        this.model1 = ''
        this.model1SearchList = []
        this.getAllModelData(value)
      }
      // 编辑
      , handleEdit (index, row) {
        console.log(index, row)
        if (row == undefined) {
          this.isEdit = false
          this.setCurModelInfo({})
        } else {
          this.isEdit = true
          this.setCurModelInfo(row)
        }
        this.dialogShow = true
      }
      // 另存为
      , handleSave (index, row) {
        this.$confirm('该操作会以这条记录为基础新加一条新记录,是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(() => {
          this.isEdit = false
          this.setCurModelInfo(row)
          this.saveFunc()
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消另存为'
          })
        })
      }
      // 删除
      , handleDelete (index, row) {
        let guids = []
          , params = {
          guid: ''
        }
        if (row) {
          guids.push(row.guid)
        } else {// 为点击批量删除时
          let selected = this.$refs.table.selection

          if (selected.length == 0) {
            this.$message({
              message: '请选择要删除的行!'
            })
            return
          }

          for (let i = 0; i < selected.length; i++) {
            guids.push(selected[i].guid)
          }
        }
        params.guid = JSON.stringify(guids)

        this.$confirm('该操作会永久删除这些记录,是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.ifLoading = true
          this.$axios.post('Regest/deleteListInputTips', params)
            .then((res) => {
              this.ifLoading = false
              let data = res.data
              if (data.isError == 'False') {
                this.$message({
                  message: '删除成功!'
                  , type: 'success'
                })
                this.getListData()
              } else {
                this.$message({
                  message: '删除失败!'
                  , type: 'warning'
                })
              }
            })
            .catch((err) => {
              this.ifLoading = false
              this.$message({
                message: '删除失败! 请刷新重试!'
                , type: 'warning'
              })
            })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      }
      // 获取当前选中模块信息
      , setCurModelInfo (row) {
        this.model0Name = row.model_1 || ''
        this.model1Name = row.model_2 || ''
        this.modelShow = row.model_info || ''
        this.fieldName = row.field_name || ''
        this.fieldShow = row.field_info || ''
        this.curGuid = row.guid || ''
        this.model0SearchList = [] // 模块一搜索集合
        this.model1SearchList = []
      }

      // 模块一搜索
      , model0Search (queryString, cb) {
        let results = queryString ? this.model0SearchList.filter(this.creatFilter0(queryString, 'model_1')) : this.model0SearchList

        cb(results)
      }
      , creatFilter0 (queryString, objName) {
        return (item) => {
          return (item[objName].toLowerCase().indexOf(queryString.toLowerCase()) === 0)
        }
      }
      // 网络获取所有模块一名称数据列表
      , getAllModelData (name) {
        let params = {}
        if (name) {
          params = {
            'module_1': name
          }
        }

        this.$axios.post('Regest/GetInputTipList_combox', params)
          .then((res) => {
            let data = res.data
            if (data.isError == 'False') {
              if (name) {
                this.model1SearchList = data.result.Table
              } else {
                this.model0SearchList = data.result.Table
              }
            }
          })
          .catch((err) => {

          })
      }
      // 模块一下拉框选择监听
      , model0Select (item) {
        console.log(item)
        this.model0Name = item.model_1
        this.model1Name = ''
        this.model1SearchList = []
        // 开始获取模块二数据
        this.getAllModelData(item.model_1)
      }
      // 模块二搜索
      , model1Search (queryString, cb) {
        let results = queryString ? this.model1SearchList.filter(this.creatFilter0(queryString, 'model_2')) : this.model1SearchList
        cb(results)
      }
      // 模块二选择监听
      , model1Select (item) {
        this.model1Name = item.model_2
        this.modelShow = item.model_info
        console.log(item)
      }
      // 进行保存
      , saveFunc () {
        let params = {
          m1: this.model0Name
          , m2: this.model1Name
          , m2desc: this.modelShow
          , zdmc: this.fieldName
          , zdmcdesc: this.fieldShow
        }
          , url = 'Regest/InsertListInputTips' // 添加一条地址
        if (params.m1.length == 0) {
          this.show0 = true
          return
        }
        if (params.m2.length == 0) {
          this.show1 = true
          return
        }
        if (params.m2desc.length == 0) {
          this.show2 = true
          return
        }
        if (params.zdmc.length == 0) {
          this.show3 = true
          return
        }
        if (params.zdmcdesc.length == 0) {
          this.show4 = true
          return
        }

        if (this.isEdit) {
          url = 'Regest/UpdateListInputTips' // 更新模块地址
          params.guid = this.curGuid
        }

        this.ifLoading = true
        this.$axios.post(url, params)
          .then((res) => {
            this.ifLoading = false
            let data = res.data
            if (data.isError == 'False') {
              this.$message({
                message: this.isEdit ? '更新成功!' : '添加成功!'
                , type: 'success'
              })

              this.getListData()

              // 清空
              this.isEdit = false
              this.curGuid = ''
              this.fieldName = ''
              this.fieldShow = ''

              if (this.goonCB) {
                // 继续为改模块添加新的字段说明
              } else {
                this.dialogShow = false
                // 应该清空所有输入框
                this.model0Name = ''
                this.model1Name = ''
                this.modelShow = ''
              }
            } else {
              this.$message({
                message: data.errorMessage
                , type: 'warning'
              })
            }
          })
          .catch((err) => {
            this.ifLoading = false
            this.$message({
              message: data.errorMessage
              , type: 'warning'
            })
          })
      }

      , inputChange (value) {
        console.log(value)
      }

      // 页码回调监听
      , sizeChangeListener (value) {
        this.pagesize = value
        this.getListData()
      }
    }
    , mounted () {
      console.log(this.$refs.tableCon.clientHeight)
      this.tableHeight = this.$refs.tableCon.clientHeight
    }
    , created () {
      let loginUser = this.$route.query.name
        , loginName = this.$store.getters.getLoginUser1.name
      if (loginUser == undefined || loginUser == '') {
        window.location.href = this.$store.getters.getloginUrl
        return
      }
      if (loginName == '') {
        loginName = loginUser
      }
      // 获取列表数据
      this.getListData()
      // 获取模块一数据
      this.getAllModelData()
    }
    , watch: {
      dialogShow (newValue) {
        if (newValue) {
          // 获取模块一数据
          this.getAllModelData()
          // 如果为编辑
          if (this.model0Name != '') {
            this.getAllModelData(this.model0Name)
          }
        }
      }
      , pageindex (newValue) {
        this.getListData()
      }
      , model0Name (newValue) {
        if (newValue != '') {
          this.show0 = false
        }
      } // 模块一名称
      , model1Name (newValue) {
        if (newValue != '') {
          this.show1 = false
        }
      } // 模块二名称
      , modelShow (newValue) {
        if (newValue != '') {
          this.show2 = false
        }
      } // 模块说明
      , fieldName (newValue) {
        if (newValue != '') {
          this.show3 = false
        }
      } // 字段名称
      , fieldShow (newValue) {
        if (newValue != '') {
          this.show4 = false
        }
      }
    }
  }
</script>

<style scoped src="@/css/dialog-reset.css"></style>
<style scoped>
  div {
    box-sizing: border-box;
  }

  p {
    margin: 0;
    padding: 0;
  }

  .content {
    width: 100%;
    height: calc(100% - 253px) !important;
    max-width: 1200px;
    box-sizing: border-box;
    margin: 8px auto;
    background: #ffffff;
    overflow: hidden;
  }

  .title-b {
    font-size: 24px;
    color: #2E2E2E;
    letter-spacing: 0;
    margin: 19px 0 12px 44px !important;
  }

  .title-b:before {
    content: '';
    position: relative;
    display: inline-block;
    font-size: 0;
    width: 6px;
    height: 20px;
    top: 2px;
    left: 0;
    margin-right: 13px;
    background: #04A4FF;
  }

  .line-gray {
    height: 1px;
    background: #EDEDED;
    margin: 0 24px;
  }

  .action-con {
    position: relative;
    width: 100%;
    height: 32px;
    line-height: 32px;
    margin-top: 22px;
    padding: 0 32px;
  }

  .action-con >>> .el-select {
    vertical-align: top;
    height: 32px;
    width: 100px;
    line-height: 32px;
  }

  .action-con >>> .el-input__inner {
    height: 28px;
    line-height: 28px;
    padding-left: 8px;
    font-size: 12px;
    border-radius: 2px;
  }

  .action-con >>> .el-input__suffix {
    height: 28px;
  }

  .action-con >>> .el-input__icon {
    line-height: 28px;
  }

  .searchCon {
    vertical-align: top;
    display: inline-block;
    width: 120px;
  }

  /*.action-con >>> input[name="searchName"] {*/
  /*padding-right: 8px;*/
  /*}*/

  .action-title {
    vertical-align: top;
    display: inline-block;
    font-size: 12px;
    color: #747474;
    letter-spacing: 0;
  }

  .title-left {
    margin-left: 10px;
  }

  .btnCommon {
    display: inline-block;
    height: 28px;
    line-height: 28px;
    text-align: center;
    border-radius: 2px;
    font-size: 13px;
    vertical-align: sub;
  }

  .searchBtn {
    width: 72px;
    height: 28px;
    margin-left: 12px;
    margin-top: 3px;
    background: #F5A623;
    color: #FFFFFF;
  }

  .lotDelBtn {
    float: right;
    width: 88px;
    margin-top: 2px;
    margin-right: 48px;
    line-height: 26px;
    box-sizing: border-box;
    background: #FFFFFF;
    border: 1px solid #F4ADAD;
    color: #ED2222;
  }

  .addBtn {
    float: right;
    width: 120px;
    margin-top: 2px;
    background: #3492FF;
    color: #FFFFFF;
  }

  .tableCon {
    width: calc(100% - 64px);
    margin: 16px 32px 0;
    height: calc(100% - 180px);
  }

  /*表格样式*/
  .tableCon >>> .el-table__header th {
    background: #F9FBFF;
  }

  .tableCon >>> td, .tableCon >>> th {
    border-color: #DFEDFF;
  }

  .tableCon >>> .el-table__row .cell {
    height: 30px;
    line-height: 30px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    font-size: 13px;
    color: #747474;
  }

  .tableCon >>> .el-table__header-wrapper th .cell {
    text-align: center;
    font-size: 13px;
    color: #2E2E2E;
  }

  .action-left {
    margin-left: 5px;
  }

  .action-common {
    font-size: 12px;
    color: #0779FF;
  }

  .action-del {
    color: #FF4D4D;
  }

  /*弹窗样式*/
  .dialog-con {
    height: 458px;
  }

  .inputHint {
    font-size: 13px;
    color: #949494;
    letter-spacing: 0;
    margin-top: 28px;
    margin-bottom: 17px;
    padding-left: 130px;
  }

  .dialog-con .red {
    color: #FF665F;
  }

  .input-con {
    height: 36px;
    margin-bottom: 7px;
    overflow: hidden;
  }

  .textarea-con {
    height: 80px;
    margin-bottom: 7px;
  }

  .textarea-con .inputCommon {
    height: auto;
  }

  .input-con label {
    display: inline-block;
    height: 36px;
    line-height: 36px;
    vertical-align: top;
    width: 196px;
    text-align: right;
  }

  .input-con label span {
    font-size: 14px;
    color: #ED2222;
  }

  .inputCommon {
    width: 340px;
    height: 36px;
  }

  .inputCommon >>> input {
    height: 36px;
    line-height: 36px;
    font-size: 14px;
    color: #373737;
  }

  .inputCommon >>> textarea {
    font-family: MicrosoftYaHei;
    height: 80px;
    line-height: 26px;
    font-size: 14px;
    color: #373737;
  }

  .itemName {
    height: 32px;
    line-height: 32px;
    font-size: 14px;
    color: #868686;
    letter-spacing: 0;
  }

  .itemName:hover {
    background: #F0F7FF;
    color: #0E76EE;
  }

  .saveBtn {
    display: inline-block;
    width: 88px;
    height: 32px;
    line-height: 32px;
    text-align: center;
    margin: 23px 12px 0 200px;
    background: #3492FF;
    border-radius: 4px;
    font-size: 14px;
    color: #FFFFFF;
  }

  .dialog-con >>> .el-checkbox__label {
    padding-left: 8px;
  }

  .showText {
    display: inline-block;
    width: auto;
    height: 24px;
    padding-right: 8px;
    margin-left: 16px;
    line-height: 24px;
    background: #FFF2F2 url("../assets/error.png") no-repeat 7px center;
    border: 1px solid #FFE3E0;
    border-radius: 4px;
    font-size: 13px;
    color: #FF4D4D;
    letter-spacing: 0;
    text-indent: 26px;
    vertical-align: super;
  }

  /*页码容器*/
  .pagination-con {
    padding-left: 22px;
    margin-top: 8px;
  }
</style>

<!--全局样式-->
<style>
  /*饿了么tips样式*/
  .el-tooltip__popper {
    max-width: 1200px;
  }

  /*饿了么select样式*/
  .el-popper .popper__arrow {
    display: none !important;
  }

  .el-popper {
    margin-top: 5px !important;
  }
</style>




// WEBPACK FOOTER //
// src/page/InputShow.vue